import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Handles the Emergent Google OAuth redirect: reads session_id from URL fragment,
// exchanges it once, then redirects to the dashboard.
export const AuthCallback = () => {
  const { completeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        await completeGoogleSession(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [completeGoogleSession, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        <p className="font-display text-2xl tracking-widest text-foreground/70">Stepping through the fog…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
